import { useSelector } from "react-redux";
import { useQuery } from "@tanstack/react-query";

import { createAxiosInstance } from "api/axiosConfig";

export const useConsultationsList = (patientId) => {

  const tenantVal =
    useSelector((state) => state.auth.user?.tenant) ||
    localStorage.getItem("kinesin-tenant");

  return useQuery({
    queryKey: ["consultationsList", patientId, tenantVal],
    queryFn: async () => {
      if (!patientId) return null;

      const axiosInstance = await createAxiosInstance();
      const response = await axiosInstance.get(
        `${tenantVal}/consultation/getbypatientid/${patientId}/details`
      );

      return response.data.sort((a, b) => {
        const dateA = new Date(a.startTime);
        const dateB = new Date(b.startTime);

        return dateB - dateA;
      });
    },
    enabled: !!patientId && !!tenantVal,
    staleTime: 1000 * 60 * 5,
    refetchOnWindowFocus: false,
    meta: { errorMessage: "Error fetching my consultations" },
  });
};

export const useMyConsultationsList = () => {

  const tenantVal =
    useSelector((state) => state.auth.user?.tenant) ||
    localStorage.getItem("kinesin-tenant");

  return useQuery({
    queryKey: ["myConsultationsList", tenantVal],
    queryFn: async () => {
      const axiosInstance = await createAxiosInstance();
      const response = await axiosInstance.get(
        `${tenantVal}/consultation/myconsultations/open`
      );
      return response.data;
    },
    enabled: !!tenantVal,
    staleTime: 1000 * 60 * 5,
    refetchOnWindowFocus: false,
    meta: { errorMessage: "Error fetching my consultations" },
  });
};
